import { Injectable } from '@angular/core';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { environment } from '../../../Environment/environment';
import { Route, Router } from '@angular/router';
// import logo from '';
@Injectable({
  providedIn: 'root'
})
export class PdfService {
  AssetbasePath:any;

/**
 *
 */
constructor( private router: Router) {
 this.AssetbasePath = environment.assetsPath;
 
}
  generatePdf(companyName: string, companyAddress: string, contactInfo:string, website:string, tableId: string, tableId2:string,productCode:string,productName:string,userInputTable:string) {
    debugger;
    const doc = new jsPDF();
    const url = this.router.url.toLowerCase();
    // doc.setFont("bold");
    // doc.text(companyName, 20, 20);


    const logoImg = new Image();
    const currentUrl = window.location.href.toLowerCase();
    if (currentUrl.includes('spineatools')) 
      {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_S.jpg';
        doc.addImage(logoImg, 'JPG', 10, 10, 80, 20);
    }
    else
    {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_PDF.png';
        doc.addImage(logoImg, 'PNG', 10, 10, 80, 15);
    }

    
    const d = new Date();
    doc.setFontSize(10);
    doc.text(d.toDateString(),15, 35);
    doc.setFont("bold");
    // doc.addFont('Roboto-Regular.ttf', 'Roboto', 'bold'); 
    doc.setFontSize(11);
    doc.text("Product Name - " + productName ,15, 40)
    doc.text("Product Code - " + productCode ,15, 45)
    // doc.setFont("bold");
    doc.setFontSize(11);
    doc.setFont('Times-Roman', 'bold'); 
    if (currentUrl.includes('spineatools'))
      {
        doc.text("SPINEA.",122, 15);
        doc.setFont('Times-Roman', 'normal');
        doc.text( "s.r.o., Ku Magašu 702/3, 080 01 Haniska,",122, 20);
        doc.text( "District of Prešov, Slovakia",122, 25);
        doc.text( "Tel: +421 51 77 00 155, Sales: +421 51 77 00 156",122, 30);
        doc.setFont('Times-Roman', 'bold');
        doc.text(website,122, 35);

      }
      else
      {
        doc.text(companyName,115, 15);
        doc.setFont('Times-Roman', 'normal');
        doc.text(companyAddress,115, 20);
        doc.text(contactInfo,115, 25);
        // doc.setFont("bold");
        doc.setFont('Times-Roman', 'bold');
        doc.text(website,115, 30);
      }

    
    // // Add company header
    // doc.setFontSize(18);
    // doc.text(companyName, 20, 20);
    // doc.setFontSize(12);
    // doc.text(companyAddress, 20, 30);

    // Get table data from HTML table
    const element = document.getElementById(tableId);
    const element1 = document.getElementById(tableId2);
    // const options = { startY: 500 };
    const options = {
        startY: 20,
        theme: 'grid',
        styles: {
          lineColor: [0, 0, 0], // Black line
          lineWidth: 0.5,
        },
        headStyles: {
          fillColor: [200, 200, 200], // Gray background for headers
          textColor: [0, 0, 0], // Black text for headers
        },
        footStyles: {
          fillColor: [200, 200, 200], // Gray background for footers
          textColor: [0, 0, 0], // Black text for footers
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240], // Light gray background for alternate rows
        },
      };
      
    //   (doc as any).autoTable({ html: element, options });
      

    // Use jspdf-autotable to parse and generate PDF table
    if (currentUrl.includes('spineatools'))
    { (doc as any).autoTable({ 
          html: element1, 
          startY: 50, 
          theme: 'grid',
          headerStyles:{fillColor: [226,0,26]},
          columnStyles: {
            0: { cellWidth: 55 }, // First column width
            1: { cellWidth: 55 }, // Second column width
            // Third column width
            // You can add more columns if needed
        }
      });
  }
  else
  {
        (doc as any).autoTable({ 
          html: element1, 
          startY: 50, 
          theme: 'grid',
          headerStyles:{fillColor: [0,0,0]},
          columnStyles: {
            0: { cellWidth: 55 }, // First column width
            1: { cellWidth: 55 }, // Second column width
            // Third column width
            // You can add more columns if needed
        }
      });
  }


const userDataTable:any = document.getElementById(userInputTable);
if (currentUrl.includes('spineatools'))
  {(doc as any).autoTable({ 
      html: userDataTable, 
      startY: 50, 
      margin: { left: 125, top: 50 },
      theme: 'grid',
      headerStyles:{fillColor: [226,0,26]},
      columnStyles: {
        0: { cellWidth: 50 }, // First column width
        1: { cellWidth: 20 }, // Second column width
        // Third column width
        // You can add more columns if needed
            }
      });
  }
  else
  {
  (doc as any).autoTable({ 
    html: userDataTable, 
    startY: 50, 
    margin: { left: 125, top: 50 },
    theme: 'grid',
    headerStyles:{fillColor: [0,0,0]},
    columnStyles: {
      0: { cellWidth: 50 }, // First column width
      1: { cellWidth: 20 }, // Second column width
       // Third column width
      // You can add more columns if needed
          }
    });
  }

    // const element1 = document.getElementById(tableId2);
    // const options = { startY: 500 };
    const options1 = {
        startY: 40,
        theme: 'grid',
        styles: {
          lineColor: [0, 0, 0], // Black line
          lineWidth: 0.5,
        },
        headStyles: {
          fillColor: [200, 200, 200], // Gray background for headers
          textColor: [0, 0, 0], // Black text for headers
        },
        footStyles: {
          fillColor: [200, 200, 200], // Gray background for footers
          textColor: [0, 0, 0], // Black text for footers
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240], // Light gray background for alternate rows
        },
      };
      
    //   (doc as any).autoTable({ html: element, options });
      

    // Use jspdf-autotable to parse and generate PDF table
    if (currentUrl.includes('spineatools'))
    {
        (doc as any).autoTable({ 
          html: element, 
          startY: 160, 
          theme: 'grid',
          headerStyles:{fillColor: [226,0,26]}
      });
    }
    
    else
    {
      (doc as any).autoTable({ 
          html: element, 
          startY: 160, 
          theme: 'grid',
          headerStyles:{fillColor: [0,0,0]}
      });
    }
      // Save the PDF
      doc.save('Spec_'+productCode+'.pdf');
}
// generate pdf for mail HP
hpPdfRequestQuote(companyName: string, companyAddress: string, contactInfo:string, website:string, tableId: string, tableId2:string,productCode:string,productName:string,quoteUserData:any,userInputTable:string): Blob {
  const doc = new jsPDF();
  const url = this.router.url.toLocaleLowerCase();
  const logoImg = new Image();
  const currentUrl = window.location.href.toLowerCase();
  if(currentUrl.includes('spineatools'))
    {
      logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_S.jpg';
      doc.addImage(logoImg, 'JPG', 10, 6, 80, 20);
    }
    else
    {
      logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_PDF.png';
      doc.addImage(logoImg, 'PNG', 10, 10, 80, 15);
    }

  const d = new Date();
  doc.setFontSize(8);
  doc.text(d.toDateString(),15, 30);
  doc.setFont('Times-Roman', 'bold');
  doc.setFontSize(9);
  doc.text("Product Name - " + productName ,15, 34)
  doc.text("Product Code - " + productCode+', '+"Quantity - " + quoteUserData.quantity+', ' ,15, 38)
  doc.text(quoteUserData.email+', '+quoteUserData.firstName+' '+quoteUserData.lastName+', '+quoteUserData.company+',' ,15, 42)
  doc.text(quoteUserData.city+', '+quoteUserData.state+' '+quoteUserData.country+', '+quoteUserData.mobile ,15, 46)
  doc.setFontSize(11);
  doc.setFont('Times-Roman', 'bold'); 
  if (currentUrl.includes('spineatools'))
  {
    doc.text("SPINEA.",122, 15);
    doc.setFont('Times-Roman', 'normal');
    doc.text( "s.r.o., Ku Magašu 702/3, 080 01 Haniska,",122, 20);
    doc.text( "District of Prešov, Slovakia",122, 25);
    doc.text( "Tel: +421 51 77 00 155, Sales: +421 51 77 00 156",122, 30);
    doc.setFont('Times-Roman', 'bold');
    doc.text(website,122, 35);
  }
  else
  {
    doc.text(companyName,115, 15);
    doc.setFont('Times-Roman', 'normal');
    doc.text(companyAddress,115, 20);
    doc.text(contactInfo,115, 25);
    doc.setFont('Times-Roman', 'bold');
    doc.text(website,115, 30);
  }
  

  const element = document.getElementById(tableId2);
  const options = {
      startY: 25,
      theme: 'grid',
      styles: {
        lineColor: [0, 0, 0], // Black line
        lineWidth: 0.5,
      },
      headStyles: {
        fillColor: [200, 200, 200], // Gray background for headers
        textColor: [0, 0, 0], // Black text for headers
      },
      footStyles: {
        fillColor: [200, 200, 200], // Gray background for footers
        textColor: [0, 0, 0], // Black text for footers
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240], // Light gray background for alternate rows
      },
    };
    if (currentUrl.includes('spineatools')) {
      (doc as any).autoTable({ 
      html: element, 
      startY: 50, 
      theme: 'grid',
      headerStyles:{fillColor: [226,0,26]},
      columnStyles: {
        0: { cellWidth: 55 }, // First column width
        1: { cellWidth: 55 }, // Second column width
         // Third column width
        // You can add more columns if needed
    }
  });
    }
    else{
      (doc as any).autoTable({ 
      html: element, 
      startY: 50, 
      theme: 'grid',
      headerStyles:{fillColor: [0,0,0]},
      columnStyles: {
        0: { cellWidth: 55 }, // First column width
        1: { cellWidth: 55 }, // Second column width
         // Third column width
        // You can add more columns if needed
    }
      });
    }  


  const element1 = document.getElementById(tableId);
  const options1 = {
      startY: 40,
      theme: 'grid',
      styles: {
        lineColor: [0, 0, 0], // Black line
        lineWidth: 0.5,
      },
      headStyles: {
        fillColor: [200, 200, 200], // Gray background for headers
        textColor: [0, 0, 0], // Black text for headers
      },
      footStyles: {
        fillColor: [200, 200, 200], // Gray background for footers
        textColor: [0, 0, 0], // Black text for footers
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240], // Light gray background for alternate rows
      },
    };
    
   if (currentUrl.includes('spineatools')) { 
  (doc as any).autoTable({ 
      html: element1, 
      startY: 160, 
      theme: 'grid',
      headerStyles:{fillColor: [226,0,26]}
  });}
  else {
  (doc as any).autoTable({ 
      html: element1, 
      startY: 150, 
      theme: 'grid',
      headerStyles:{fillColor: [0,0,0]}
  });
  }
  const userDataTable:any = document.getElementById(userInputTable);
  if (currentUrl.includes('spineatools'))
  {
          (doc as any).autoTable({ 
          html: userDataTable, 
          startY: 50, 
          margin: { left: 125, top: 50 },
          theme: 'grid',
          headerStyles:{fillColor: [226,0,26]},
          columnStyles: {
            0: { cellWidth: 50 }, // First column width
            1: { cellWidth: 20 }, // Second column width
            // Third column width
            // You can add more columns if needed
        }
      });
  }
  else
  {
        (doc as any).autoTable({ 
          html: userDataTable, 
          startY: 50, 
          margin: { left: 125, top: 50 },
          theme: 'grid',
          headerStyles:{fillColor: [0,0,0]},
          columnStyles: {
            0: { cellWidth: 50 }, // First column width
            1: { cellWidth: 20 }, // Second column width
            // Third column width
            // You can add more columns if needed
        }
      });
    }
  const pdfBlob = doc.output('blob');
    return pdfBlob;
}

// generate pdf for mail HPA
hpaPdfRequestQuote(companyName: string, companyAddress: string, contactInfo:string, website:string, tableId: string, tableId2:string,productCode:string,productName:string,quoteUserData:any,userInputTable:string): Blob {
  const doc = new jsPDF();
    // doc.setFont("bold");
    // doc.text(companyName, 20, 20);


    const url = this.router.url.toLocaleLowerCase();
    const logoImg = new Image();
    const currentUrl = window.location.href.toLowerCase();
    if (currentUrl.includes('spineatools')) 
      {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_S.jpg';
        doc.addImage(logoImg, 'JPG', 10, 6, 80, 20);
    }
    else
    {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_PDF.png';
        doc.addImage(logoImg, 'PNG', 10, 10, 80, 15);
    }



    const d = new Date();
    doc.setFontSize(10);
    doc.text(d.toDateString(),15, 35);
    doc.setFont('Times-Roman', 'bold');
    // doc.addFont('Roboto-Regular.ttf', 'Roboto', 'bold'); 
    doc.setFontSize(11);
    doc.text("Product Name - " + productName ,15, 39)
    doc.text("Product Code - " + productCode+', '+"Quantity - " + quoteUserData.quantity+', ' ,15, 43)
    doc.text(quoteUserData.email+', '+quoteUserData.firstName+' '+quoteUserData.lastName+', '+quoteUserData.company+',' ,15, 47)
    doc.text(quoteUserData.city+', '+quoteUserData.state+' '+quoteUserData.country+', '+quoteUserData.mobile ,15, 51)
    // doc.setFont("bold");
    doc.setFontSize(11);
    doc.setFont('Times-Roman', 'bold'); 
    if (currentUrl.includes('spineatools'))
    {
      doc.text("SPINEA.",122, 15);
      doc.setFont('Times-Roman', 'normal');
      doc.text( "s.r.o., Ku Magašu 702/3, 080 01 Haniska,",122, 20);
      doc.text( "District of Prešov, Slovakia",122, 25);
      doc.text( "Tel: +421 51 77 00 155, Sales: +421 51 77 00 156",122, 30);
      doc.setFont('Times-Roman', 'bold');
      doc.text(website,122, 35);
    }
    else
    {
      doc.text(companyName,115, 15);
      doc.setFont('Times-Roman', 'normal');
      doc.text(companyAddress,115, 20);
      doc.text(contactInfo,115, 25);
      // doc.setFont("bold");
      doc.setFont('Times-Roman', 'bold');
      doc.text(website,115, 30);
    }    
    // // Add company header
    // doc.setFontSize(18);
    // doc.text(companyName, 20, 20);
    // doc.setFontSize(12);
    // doc.text(companyAddress, 20, 30);

    // Get table data from HTML table
    const element = document.getElementById(tableId);
    // const options = { startY: 500 };
    const options = {
        startY: 20,
        theme: 'grid',
        styles: {
          lineColor: [0, 0, 0], // Black line
          lineWidth: 0.5,
        },
        headStyles: {
          fillColor: [200, 200, 200], // Gray background for headers
          textColor: [0, 0, 0], // Black text for headers
        },
        footStyles: {
          fillColor: [200, 200, 200], // Gray background for footers
          textColor: [0, 0, 0], // Black text for footers
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240], // Light gray background for alternate rows
        },
      };
      
    //   (doc as any).autoTable({ html: element, options });
      

    // Use jspdf-autotable to parse and generate PDF table
    if (currentUrl.includes('spineatools'))
      {
        (doc as any).autoTable({
          html: element,
          startY: 54,
          theme: 'grid',
          headerStyles:{fillColor: [226,0,26]},
          columnStyles: {
            0: { cellWidth: 15 }, // First column width
            1: { cellWidth: 90 }, // Second column width
             // Third column width
            // You can add more columns if needed
          }
        });
      }
      else
      {
        (doc as any).autoTable({ 
            html: element, 
            startY: 54, 
            theme: 'grid',
            headerStyles:{fillColor: [0,0,0]},
            columnStyles: {
              0: { cellWidth: 15 }, // First column width
              1: { cellWidth: 90 }, // Second column width
              // Third column width
              // You can add more columns if needed
          }
        });
      }
    const userDataTable:any = document.getElementById(userInputTable);
    if (currentUrl.includes('spineatools'))
      {
        (doc as any).autoTable({
          html: userDataTable,
          startY: 54,
          margin: { left: 125, top: 50 },
          theme: 'grid',
          headerStyles:{fillColor: [226,0,26]},
          columnStyles: {
            0: { cellWidth: 50 }, // First column width
            1: { cellWidth: 20 }, // Second column width
             // Third column width
            // You can add more columns if needed
          }
        });
      }
    else
    {  
        (doc as any).autoTable({ 
          html: userDataTable, 
          startY: 54, 
          margin: { left: 125, top: 50 },
          theme: 'grid',
          headerStyles:{fillColor: [0,0,0]},
          columnStyles: {
            0: { cellWidth: 50 }, // First column width
            1: { cellWidth: 20 }, // Second column width
            // Third column width
            // You can add more columns if needed
        }
      });
    }

    const element1 = document.getElementById(tableId2);
    // const options = { startY: 500 };
    const options1 = {
        startY: 40,
        theme: 'grid',
        styles: {
          lineColor: [0, 0, 0], // Black line
          lineWidth: 0.5,
        },
        headStyles: {
          fillColor: [200, 200, 200], // Gray background for headers
          textColor: [0, 0, 0], // Black text for headers
        },
        footStyles: {
          fillColor: [200, 200, 200], // Gray background for footers
          textColor: [0, 0, 0], // Black text for footers
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240], // Light gray background for alternate rows
        },
      };
      
    //   (doc as any).autoTable({ html: element, options });
      

    // Use jspdf-autotable to parse and generate PDF table
          if (currentUrl.includes('spineatools')) {
    (doc as any).autoTable({ 
        html: element1, 
        startY: 150, 
        theme: 'grid',
        headerStyles:{fillColor: [226,0,26]}
    });
  }
  else{
    (doc as any).autoTable({ 
        html: element1, 
        startY: 150, 
        theme: 'grid',
        headerStyles:{fillColor: [0,0,0]}
    });
  }
  const pdfBlob = doc.output('blob');
    return pdfBlob;
}




// generate pdf for mail RG
rgPdfRequestQuote(companyName: string, companyAddress: string, contactInfo:string, website:string, tableId: string, tableId2:string,productCode:string,productName:string,quoteUserData:any,userInputTable:string): Blob {
  const doc = new jsPDF();
    // doc.setFont("bold");
    // doc.text(companyName, 20, 20);


    const url = this.router.url.toLocaleLowerCase();
    const currentUrl = window.location.href.toLowerCase();
    const logoImg = new Image();
    if(currentUrl.includes('spineatools'))
      {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_S.jpg';
        doc.addImage(logoImg, 'JPG', 10, 6, 80, 20);
    }
    else
    {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_PDF.png';
        doc.addImage(logoImg, 'PNG', 10, 10, 80, 15);
    }



    const d = new Date();
    doc.setFontSize(10);
    doc.text(d.toDateString(),15, 35);
    doc.setFont('Times-Roman', 'bold');
    // doc.addFont('Roboto-Regular.ttf', 'Roboto', 'bold'); 
    doc.setFontSize(11);
    doc.text("Product Name - " + productName ,15, 39)
    doc.text("Product Code - " + productCode+', '+"Quantity - " + quoteUserData.quantity+', ' ,15, 43)
  doc.text(quoteUserData.email+', '+quoteUserData.firstName+' '+quoteUserData.lastName+', '+quoteUserData.company+',' ,15, 47)
  doc.text(quoteUserData.city+', '+quoteUserData.state+' '+quoteUserData.country+', '+quoteUserData.mobile ,15, 51)
    // doc.setFont("bold");
    doc.setFontSize(11);
    doc.setFont('Times-Roman', 'bold'); 
    if(currentUrl.includes('spineatools'))
    {
      doc.text("SPINEA.",122, 15);
      doc.setFont('Times-Roman', 'normal');
      doc.text( "s.r.o., Ku Magašu 702/3, 080 01 Haniska,",122, 20);
      doc.text( "District of Prešov, Slovakia",122, 25);
      doc.text( "Tel: +421 51 77 00 155, Sales: +421 51 77 00 156",122, 30);
      doc.setFont('Times-Roman', 'bold');
      doc.text(website,122, 35);
    }
    else
    {
      doc.text(companyName,115, 15);
      doc.setFont('Times-Roman', 'normal');
      doc.text(companyAddress,115, 20);
      doc.text(contactInfo,115, 25);
      // doc.setFont("bold");
      doc.setFont('Times-Roman', 'bold');
      doc.text(website,115, 30);
    }
    // // Add company header
    // doc.setFontSize(18);
    // doc.text(companyName, 20, 20);
    // doc.setFontSize(12);
    // doc.text(companyAddress, 20, 30);
    // Get table data from HTML table
    const element = document.getElementById(tableId);
    // const options = { startY: 500 };
    const options = {
        startY: 20,
        theme: 'grid',
        styles: {
          lineColor: [0, 0, 0], // Black line
          lineWidth: 0.5,
        },
        headStyles: {
          fillColor: [200, 200, 200], // Gray background for headers
          textColor: [0, 0, 0], // Black text for headers
        },
        footStyles: {
          fillColor: [200, 200, 200], // Gray background for footers
          textColor: [0, 0, 0], // Black text for footers
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240], // Light gray background for alternate rows
        },
      };
      
    //   (doc as any).autoTable({ html: element, options });
      

    // Use jspdf-autotable to parse and generate PDF table
    if(currentUrl.includes('spineatools')) {
    (doc as any).autoTable({ 
        html: element, 
        startY: 54, 
        theme: 'grid',
        headerStyles:{fillColor: [226,0,26]},
        columnStyles: {
        0: { cellWidth: 15 }, // First column width
        1: { cellWidth: 90 }, // Second column width
         // Third column width
        // You can add more columns if needed
        }
        });
     }
  else{
    (doc as any).autoTable({ 
        html: element, 
        startY: 54, 
        theme: 'grid',
        headerStyles:{fillColor: [0,0,0]},
        columnStyles: {
        0: { cellWidth: 15 }, // First column width
        1: { cellWidth: 90 }, // Second column width
         // Third column width
        // You can add more columns if needed
    }
    });
  }
  const userDataTable:any = document.getElementById(userInputTable);
  if(currentUrl.includes('spineatools'))
    {
      (doc as any).autoTable({ 
    html: userDataTable, 
    startY: 54, 
    margin: { left: 125, top: 50 },
    theme: 'grid',
    headerStyles:{fillColor: [226,0,26]},
    columnStyles: {
      0: { cellWidth: 50 }, // First column width
      1: { cellWidth: 20 }, // Second column width
       // Third column width
      // You can add more columns if needed
        }
      });
    }
    else
    {
      (doc as any).autoTable({ 
    html: userDataTable, 
    startY: 54, 
    margin: { left: 125, top: 50 },
    theme: 'grid',
    headerStyles:{fillColor: [0,0,0]},
    columnStyles: {
      0: { cellWidth: 50 }, // First column width
      1: { cellWidth: 20 }, // Second column width
       // Third column width
      // You can add more columns if needed
        }
      });
    }
   const element1 = document.getElementById(tableId2);
    // const options = { startY: 500 };
    const options1 = {
        startY: 40,
        theme: 'grid',
        styles: {
          lineColor: [0, 0, 0], // Black line
          lineWidth: 0.5,
        },
        headStyles: {
          fillColor: [200, 200, 200], // Gray background for headers
          textColor: [0, 0, 0], // Black text for headers
        },
        footStyles: {
          fillColor: [200, 200, 200], // Gray background for footers
          textColor: [0, 0, 0], // Black text for footers
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240], // Light gray background for alternate rows
        },
      };
      
    //   (doc as any).autoTable({ html: element, options });
      

    // Use jspdf-autotable to parse and generate PDF table
    if(currentUrl.includes('spineatools')) {
    (doc as any).autoTable({ 
        html: element1, 
        startY: 182, 
        theme: 'grid',
        headerStyles:{fillColor: [226,0,26]}
    });
  }
  else{
    (doc as any).autoTable({ 
        html: element1, 
        startY: 182, 
        theme: 'grid',
        headerStyles:{fillColor: [0,0,0]}
    });
  }
  const pdfBlob = doc.output('blob');
    return pdfBlob;
}



// generate pdf for mail B
bPdfRequestQuote(companyName: string, companyAddress: string, contactInfo:string, website:string, tableId: string, tableId2:string,tableId3:string,productCode:string,productName:string,quoteUserData:any,userInputTable:string): Blob {
  const doc = new jsPDF();
    // doc.setFont("bold");
    // doc.text(companyName, 20, 20);


    const url = this.router.url.toLocaleLowerCase();
    const currUrl = window.location.href.toLowerCase()
    const logoImg = new Image();
    
    if(currUrl.includes('spineatools'))
      {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_S.jpg';
        doc.addImage(logoImg, 'JPG', 10, 6, 80, 20);
    }
    else
    {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_PDF.png';
        doc.addImage(logoImg, 'PNG', 10, 10, 80, 15);
    }



    const d = new Date();
    doc.setFontSize(10);
    doc.text(d.toDateString(),15, 35);
    doc.setFont('Times-Roman', 'bold');
    // doc.addFont('Roboto-Regular.ttf', 'Roboto', 'bold'); 
    doc.setFontSize(11);
    doc.text("Product Name - " + productName ,15, 39)
    doc.text("Product Code - " + productCode+', '+"Quantity - " + quoteUserData.quantity+', ' ,15, 43)
  doc.text(quoteUserData.email+', '+quoteUserData.firstName+' '+quoteUserData.lastName+', '+quoteUserData.company+',' ,15, 47)
  doc.text(quoteUserData.city+', '+quoteUserData.state+' '+quoteUserData.country+', '+quoteUserData.mobile ,15, 51)
    // doc.setFont("bold");
    doc.setFontSize(11);
    doc.setFont('Times-Roman', 'bold'); 
    const currentUrl = window.location.href.toLowerCase();
    if(currentUrl.includes('spineatools'))
    {
      doc.text("SPINEA.",122, 15);
      doc.setFont('Times-Roman', 'normal');
      doc.text( "s.r.o., Ku Magašu 702/3, 080 01 Haniska,",122, 20);
      doc.text( "District of Prešov, Slovakia",122, 25);
      doc.text( "Tel: +421 51 77 00 155, Sales: +421 51 77 00 156",122, 30);
      doc.setFont('Times-Roman', 'bold');
      doc.text(website,122, 35);
    }
    else
    {
      doc.text(companyName,115, 15);
      doc.setFont('Times-Roman', 'normal');
      doc.text(companyAddress,115, 20);
      doc.text(contactInfo,115, 25);
      // doc.setFont("bold");
      doc.setFont('Times-Roman', 'bold');
      doc.text(website,115, 30);
    }

    
    // // Add company header
    // doc.setFontSize(18);
    // doc.text(companyName, 20, 20);
    // doc.setFontSize(12);
    // doc.text(companyAddress, 20, 30);

    // Get table data from HTML table
    const element = document.getElementById(tableId);
    // const options = { startY: 500 };
    const options = {
        startY: 20,
        theme: 'grid',
        styles: {
          lineColor: [0, 0, 0], // Black line
          lineWidth: 0.5,
        },
        headStyles: {
          fillColor: [200, 200, 200], // Gray background for headers
          textColor: [0, 0, 0], // Black text for headers
        },
        footStyles: {
          fillColor: [200, 200, 200], // Gray background for footers
          textColor: [0, 0, 0], // Black text for footers
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240], // Light gray background for alternate rows
        },
      };
      
    //   (doc as any).autoTable({ html: element, options });
      

    // Use jspdf-autotable to parse and generate PDF table
    if (currentUrl.includes('spineatools')) {
    (doc as any).autoTable({ 
        html: element, 
        startY: 54, 
        theme: 'grid',
        headerStyles:{fillColor: [226,0,26]},
        columnStyles: {
          0: { cellWidth: 15 }, // First column width
          1: { cellWidth: 90 }, // Second column width
           // Third column width
          // You can add more columns if needed
      }
    });
  }
  else{
    (doc as any).autoTable({ 
        html: element, 
        startY: 54, 
        theme: 'grid',
        headerStyles:{fillColor: [0,0,0]},
        columnStyles: {
          0: { cellWidth: 15 }, // First column width
          1: { cellWidth: 90 }, // Second column width
           // Third column width
          // You can add more columns if needed
      }
    });
  }
  const userDataTable:any = document.getElementById(userInputTable);
  if(currentUrl.includes('spineatools')){
    (doc as any).autoTable({ 
      html: userDataTable, 
      startY: 54, 
      margin: { left: 125, top: 50 },
      theme: 'grid',
      headerStyles:{fillColor: [226,0,26]},
      columnStyles: {
        0: { cellWidth: 50 }, // First column width
        1: { cellWidth: 20 }, // Second column width
         // Third column width
        // You can add more columns if needed
    }
  });
  }
  else{
    (doc as any).autoTable({ 
      html: userDataTable, 
      startY: 54, 
      margin: { left: 125, top: 50 },
      theme: 'grid',
      headerStyles:{fillColor: [0,0,0]},
      columnStyles: {
        0: { cellWidth: 50 }, // First column width
        1: { cellWidth: 20 }, // Second column width
         // Third column width
        // You can add more columns if needed
    }
  });
}


    const element1 = document.getElementById(tableId2);
    // const options = { startY: 500 };
    const options1 = {
        startY: 40,
        theme: 'grid',
        styles: {
          lineColor: [0, 0, 0], // Black line
          lineWidth: 0.5,
        },
        headStyles: {
          fillColor: [200, 200, 200], // Gray background for headers
          textColor: [0, 0, 0], // Black text for headers
        },
        footStyles: {
          fillColor: [200, 200, 200], // Gray background for footers
          textColor: [0, 0, 0], // Black text for footers
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240], // Light gray background for alternate rows
        },
      };
      
    //   (doc as any).autoTable({ html: element, options });
      

    // Use jspdf-autotable to parse and generate PDF table
    if(currentUrl.includes('spineatools')) {
    (doc as any).autoTable({ 
        html: element1, 
        startY: 155, 
        theme: 'grid',
        headerStyles:{fillColor: [226,0,26]}
    });
  }
  else{
    (doc as any).autoTable({ 
        html: element1, 
        startY: 150, 
        theme: 'grid',
        headerStyles:{fillColor: [0,0,0]}
    });
  }



    const element3 = document.getElementById(tableId3);
    if(currentUrl.includes('spineatools')) {
    (doc as any).autoTable({ 
      html: element3, 
      startY: 246, 
      theme: 'grid',
      headerStyles:{fillColor: [226,0,26]}
  });
}
else{
  (doc as any).autoTable({ 
      html: element3, 
      startY: 246, 
      theme: 'grid',
      headerStyles:{fillColor: [0,0,0]}
  });
}
  const pdfBlob = doc.output('blob');
    return pdfBlob;
}



// generate pdf for mail F
fPdfRequestQuote(companyName: string, companyAddress: string, contactInfo:string, website:string, tableId: string, tableId2:string,productCode:string,productName:string,quoteUserData:any,userInputTable:string) {
  const doc = new jsPDF();
  // doc.setFont("bold");
  // doc.text(companyName, 20, 20);
    const url = this.router.url.toLocaleLowerCase();
    const logoImg = new Image();
    const currentUrl = window.location.href.toLowerCase();
    if(currentUrl.includes('spinea') ) 
      {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_S.jpg';
        doc.addImage(logoImg, 'JPG', 10, 6, 80, 20);
    }
    else
    {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_PDF.png';
        doc.addImage(logoImg, 'PNG', 10, 10, 80, 15);
    }



  const d = new Date();
  doc.setFontSize(10);
  doc.text(d.toDateString(),15, 35);
  doc.setFont('Times-Roman', 'bold');
  // doc.addFont('Roboto-Regular.ttf', 'Roboto', 'bold'); 
  doc.setFontSize(11);
  doc.text("Product Name - " + productName ,15, 39)
    doc.text("Product Code - " + productCode+', '+"Quantity - " + quoteUserData.quantity+', ' ,15, 43)
  doc.text(quoteUserData.email+', '+quoteUserData.firstName+' '+quoteUserData.lastName+', '+quoteUserData.company+',' ,15, 47)
  doc.text(quoteUserData.city+', '+quoteUserData.state+' '+quoteUserData.country+', '+quoteUserData.mobile ,15, 51)
  // doc.setFont("bold");
  doc.setFontSize(11);
  doc.setFont('Times-Roman', 'bold'); 
  if (currentUrl.includes('spineatools'))
    {
        doc.text("SPINEA.",122, 15);
        doc.setFont('Times-Roman', 'normal');
        doc.text( "s.r.o., Ku Magašu 702/3, 080 01 Haniska,",122, 20);
        doc.text( "District of Prešov, Slovakia",122, 25);
        doc.text( "Tel: +421 51 77 00 155, Sales: +421 51 77 00 156",122, 30);
        doc.setFont('Times-Roman', 'bold');
        doc.text(website,122, 35);
    }
  else
    {
      doc.text(companyName,115, 15);
      doc.setFont('Times-Roman', 'normal');
      doc.text(companyAddress,115, 20);
      doc.text(contactInfo,115, 25);
      // doc.setFont("bold");
      doc.setFont('Times-Roman', 'bold');
      doc.text(website,115, 30);
    }

  
  // // Add company header
  // doc.setFontSize(18);
  // doc.text(companyName, 20, 20);
  // doc.setFontSize(12);
  // doc.text(companyAddress, 20, 30);

  // Get table data from HTML table
  const element = document.getElementById(tableId);
  // const options = { startY: 500 };
  const options = {
      startY: 20,
      theme: 'grid',
      styles: {
        lineColor: [0, 0, 0], // Black line
        lineWidth: 0.5,
      },
      headStyles: {
        fillColor: [200, 200, 200], // Gray background for headers
        textColor: [0, 0, 0], // Black text for headers
      },
      footStyles: {
        fillColor: [200, 200, 200], // Gray background for footers
        textColor: [0, 0, 0], // Black text for footers
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240], // Light gray background for alternate rows
      },
    };
    
  //   (doc as any).autoTable({ html: element, options });
    

  // Use jspdf-autotable to parse and generate PDF table
  if(currentUrl.includes('spineatools')) {
  (doc as any).autoTable({ 
      html: element, 
      startY: 54, 
      theme: 'grid',
      headerStyles:{fillColor: [226,0,26]},
      columnStyles: {
        0: { cellWidth: 15 }, // First column width
        1: { cellWidth: 90 }, // Second column width
         // Third column width
        // You can add more columns if needed
    }
  });}
  else{
    (doc as any).autoTable({ 
      html: element, 
      startY: 54, 
      theme: 'grid',
      headerStyles:{fillColor: [0,0,0]},
      columnStyles: {
        0: { cellWidth: 15 }, // First column width
        1: { cellWidth: 90 }, // Second column width
         // Third column width
        // You can add more columns if needed
    }
  });}
  const userDataTable:any = document.getElementById(userInputTable);
  if(currentUrl.includes('spineatools'))
    {
      (doc as any).autoTable({ 
        html: userDataTable, 
        startY: 54, 
        margin: { left: 125, top: 50 },
        theme: 'grid',
        headerStyles:{fillColor: [226,0,26]},
        columnStyles: {
            0: { cellWidth: 50 }, // First column width
            1: { cellWidth: 20 }, // Second column width
       // Third column width
      // You can add more columns if needed
        }
    });
    }
  else
  {
     (doc as any).autoTable({ 
        html: userDataTable, 
        startY: 54, 
        margin: { left: 125, top: 50 },
        theme: 'grid',
        headerStyles:{fillColor: [0,0,0]},
        columnStyles: {
          0: { cellWidth: 50 }, // First column width
          1: { cellWidth: 20 }, // Second column width
       // Third column width
      // You can add more columns if needed
          }
    });
  }
  const element1 = document.getElementById(tableId2);
  // const options = { startY: 500 };
  const options1 = {
      startY: 40,
      theme: 'grid',
      styles: {
        lineColor: [0, 0, 0], // Black line
        lineWidth: 0.5,
      },
      headStyles: {
        fillColor: [200, 200, 200], // Gray background for headers
        textColor: [0, 0, 0], // Black text for headers
      },
      footStyles: {
        fillColor: [200, 200, 200], // Gray background for footers
        textColor: [0, 0, 0], // Black text for footers
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240], // Light gray background for alternate rows
      },
    };
    
  //   (doc as any).autoTable({ html: element, options });
    

  // Use jspdf-autotable to parse and generate PDF table
  if(currentUrl.includes('spineatools')) {
  (doc as any).autoTable({ 
      html: element1, 
      startY: 146, 
      theme: 'grid',
      headerStyles:{fillColor: [226,0,26]}
  });
}
else{
  (doc as any).autoTable({ 
      html: element1, 
      startY: 146, 
      theme: 'grid',
      headerStyles:{fillColor: [0,0,0]}
  });
}

  const pdfBlob = doc.output('blob');
  return pdfBlob;
}

  generatePdfRG(companyName: string, companyAddress: string, contactInfo:string, website:string, tableId: string, tableId2:string,productCode:string,productName:string,userInputTable:string) {
    const doc = new jsPDF();
    // doc.setFont("bold");
    // doc.text(companyName, 20, 20);

   const url = this.router.url.toLowerCase();
    // doc.setFont("bold");
    // doc.text(companyName, 20, 20);

    const currentUrl = window.location.href.toLowerCase();
    const logoImg = new Image();
    if(currentUrl.includes('spineatools') ) 
      {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_S.jpg';
        doc.addImage(logoImg, 'JPG', 10, 10, 80, 20);
    }
    else
    {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_PDF.png';
        doc.addImage(logoImg, 'PNG', 10, 10, 80, 15);
    }


    const d = new Date();
    doc.setFontSize(10);
    doc.text(d.toDateString(),15, 35);
    doc.setFont("bold");
    // doc.addFont('Roboto-Regular.ttf', 'Roboto', 'bold'); 
    doc.setFontSize(11);
    doc.text("Product Name - " + productName ,15, 40)
    doc.text("Product Code - " + productCode ,15, 45)
    // doc.setFont("bold");
    doc.setFontSize(11);
    doc.setFont('Times-Roman', 'bold'); 
    if (currentUrl.includes('spineatools'))
      {
        doc.text("SPINEA.",122, 15);
        doc.setFont('Times-Roman', 'normal');
        doc.text( "s.r.o., Ku Magašu 702/3, 080 01 Haniska,",122, 20);
        doc.text( "District of Prešov, Slovakia",122, 25);
        doc.text( "Tel: +421 51 77 00 155, Sales: +421 51 77 00 156",122, 30);
        doc.setFont('Times-Roman', 'bold');
        doc.text(website,122, 35);
      }
      else
      {
        doc.text(companyName,115, 15);
        doc.setFont('Times-Roman', 'normal');
        doc.text(companyAddress,115, 20);
        doc.text(contactInfo,115, 25);
        // doc.setFont("bold");
        doc.setFont('Times-Roman', 'bold');
        doc.text(website,115, 30);
      }

    
    // // Add company header
    // doc.setFontSize(18);
    // doc.text(companyName, 20, 20);
    // doc.setFontSize(12);
    // doc.text(companyAddress, 20, 30);

    // Get table data from HTML table
    const element = document.getElementById(tableId);
    // const options = { startY: 500 };
    const options = {
        startY: 20,
        theme: 'grid',
        styles: {
          lineColor: [0, 0, 0], // Black line
          lineWidth: 0.5,
        },
        headStyles: {
          fillColor: [200, 200, 200], // Gray background for headers
          textColor: [0, 0, 0], // Black text for headers
        },
        footStyles: {
          fillColor: [200, 200, 200], // Gray background for footers
          textColor: [0, 0, 0], // Black text for footers
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240], // Light gray background for alternate rows
        },
      };
      
    //   (doc as any).autoTable({ html: element, options });
      

    // Use jspdf-autotable to parse and generate PDF table
    if(currentUrl.includes('spineatools') )
      {
        (doc as any).autoTable({ 
          html: element, 
          startY: 50, 
          theme: 'grid',
          headerStyles:{fillColor: [226,0,26]},
          columnStyles: {
            0: { cellWidth: 15 }, // First column width
            1: { cellWidth: 90 }, // Second column width
            // Third column width
            // You can add more columns if needed
              }
          });
      }
    else
    {  
        (doc as any).autoTable({ 
          html: element, 
          startY: 50, 
          theme: 'grid',
          headerStyles:{fillColor: [0,0,0]},
          columnStyles: {
            0: { cellWidth: 15 }, // First column width
            1: { cellWidth: 90 }, // Second column width
            // Third column width
            // You can add more columns if needed
        }
      });
    }


const userDataTable:any = document.getElementById(userInputTable);
if(currentUrl.includes('spineatools') )
{
  (doc as any).autoTable({ 
    html: userDataTable, 
    startY: 50, 
    margin: { left: 125, top: 50 },
    theme: 'grid',
    headerStyles:{fillColor: [226,0,26]},
    columnStyles: {
      0: { cellWidth: 50 }, // First column width
      1: { cellWidth: 20 }, // Second column width
       // Third column width
      // You can add more columns if needed
        }
    });
}
else
{
  (doc as any).autoTable({ 
    html: userDataTable, 
    startY: 50, 
    margin: { left: 125, top: 50 },
    theme: 'grid',
    headerStyles:{fillColor: [0,0,0]},
    columnStyles: {
      0: { cellWidth: 50 }, // First column width
      1: { cellWidth: 20 }, // Second column width
       // Third column width
      // You can add more columns if needed
        }
    });
}
    const element1 = document.getElementById(tableId2);
    // const options = { startY: 500 };
    const options1 = {
        startY: 40,
        theme: 'grid',
        styles: {
          lineColor: [0, 0, 0], // Black line
          lineWidth: 0.5,
        },
        headStyles: {
          fillColor: [200, 200, 200], // Gray background for headers
          textColor: [0, 0, 0], // Black text for headers
        },
        footStyles: {
          fillColor: [200, 200, 200], // Gray background for footers
          textColor: [0, 0, 0], // Black text for footers
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240], // Light gray background for alternate rows
        },
      };
      
    //   (doc as any).autoTable({ html: element, options });
      

    // Use jspdf-autotable to parse and generate PDF table
    if(currentUrl.includes('spineatools') )
    {
      (doc as any).autoTable({ 
        html: element1, 
        startY: 180, 
        theme: 'grid',
        headerStyles:{fillColor: [226,0,26]}
    });
    }
    else
    {
      (doc as any).autoTable({ 
        html: element1, 
        startY: 180, 
        theme: 'grid',
        headerStyles:{fillColor: [0,0,0]}
        });
    }
   
    // Save the PDF
    doc.save('Spec_'+productCode+'.pdf');
  }

  generatePdfHPA(companyName: string, companyAddress: string, contactInfo:string, website:string, tableId: string, tableId2:string,productCode:string,productName:string,userInputTable:string) {
    const doc = new jsPDF();
    // doc.setFont("bold");
    // doc.text(companyName, 20, 20);

    const currentUrl = window.location.href.toLowerCase();
    const logoImg = new Image();
    if(currentUrl.includes('spineatools') )
      {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_S.jpg';
        doc.addImage(logoImg, 'JPG', 10, 10, 80, 20);
    }
    else
    {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_PDF.png';
        doc.addImage(logoImg, 'PNG', 10, 10, 80, 15);
    }
    const d = new Date();
    doc.setFontSize(10);
    doc.text(d.toDateString(),15, 35);
    doc.setFont("bold");
    // doc.addFont('Roboto-Regular.ttf', 'Roboto', 'bold'); 
    doc.setFontSize(11);
    doc.text("Product Name - " + productName ,15, 40)
    doc.text("Product Code - " + productCode ,15, 45)
    // doc.setFont("bold");
    doc.setFontSize(11);
    doc.setFont('Times-Roman', 'bold'); 
     if (currentUrl.includes('spineatools'))
      {
        doc.text("SPINEA.",122, 15);
        doc.setFont('Times-Roman', 'normal');
        doc.text( "s.r.o., Ku Magašu 702/3, 080 01 Haniska,",122, 20);
        doc.text( "District of Prešov, Slovakia",122, 25);
        doc.text( "Tel: +421 51 77 00 155, Sales: +421 51 77 00 156",122, 30);
        doc.setFont('Times-Roman', 'bold');
        doc.text(website,122, 35);

      }
      else
      {
        doc.text(companyName,115, 15);
        doc.setFont('Times-Roman', 'normal');
        doc.text(companyAddress,115, 20);
        doc.text(contactInfo,115, 25);
        // doc.setFont("bold");
        doc.setFont('Times-Roman', 'bold');
        doc.text(website,115, 30);
      }

    
    // // Add company header
    // doc.setFontSize(18);
    // doc.text(companyName, 20, 20);
    // doc.setFontSize(12);
    // doc.text(companyAddress, 20, 30);

    // Get table data from HTML table
    const element = document.getElementById(tableId);
    // const options = { startY: 500 };
    const options = {
        startY: 20,
        theme: 'grid',
        styles: {
          lineColor: [0, 0, 0], // Black line
          lineWidth: 0.5,
        },
        headStyles: {
          fillColor: [200, 200, 200], // Gray background for headers
          textColor: [0, 0, 0], // Black text for headers
        },
        footStyles: {
          fillColor: [200, 200, 200], // Gray background for footers
          textColor: [0, 0, 0], // Black text for footers
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240], // Light gray background for alternate rows
        },
      };
      
    //   (doc as any).autoTable({ html: element, options });
      

    // Use jspdf-autotable to parse and generate PDF table
     if (currentUrl.includes('spineatools'))
      {
        (doc as any).autoTable({ 
        html: element, 
        startY: 50, 
        theme: 'grid',
        headerStyles:{fillColor: [226,0,26]},
        columnStyles: {
          0: { cellWidth: 15 }, // First column width
          1: { cellWidth: 90 }, // Second column width
           // Third column width
          // You can add more columns if needed
          }
        });
      }
      else
      {
        (doc as any).autoTable({ 
        html: element, 
        startY: 50, 
        theme: 'grid',
        headerStyles:{fillColor: [0,0,0]},
        columnStyles: {
          0: { cellWidth: 15 }, // First column width
          1: { cellWidth: 90 }, // Second column width
           // Third column width
          // You can add more columns if needed
          }
        });
      }    
    const userDataTable:any = document.getElementById(userInputTable);
     if (currentUrl.includes('spineatools'))
    {
      (doc as any).autoTable({
        html: userDataTable, 
      startY: 50, 
      margin: { left: 125, top: 50 },
      theme: 'grid',
      headerStyles:{fillColor: [226,0,26]},        
        columnStyles: {
          0: { cellWidth: 50 }, // First column width
          1: { cellWidth: 20 }, // Second column width
           // Third column width
          // You can add more columns if needed
        }
      })
    }
    else
    {
      (doc as any).autoTable({ 
        html: userDataTable, 
      startY: 50, 
      margin: { left: 125, top: 50 },
      theme: 'grid',
        headerStyles:{fillColor: [0,0,0]},
        columnStyles: {
          0: { cellWidth: 50 }, // First column width
          1: { cellWidth: 20 }, // Second column width
          // Third column width
          // You can add more columns if needed
          }
        });
    }
 const element1 = document.getElementById(tableId2);
    // const options = { startY: 500 };
    const options1 = {
        startY: 40,
        theme: 'grid',
        styles: {
          lineColor: [0, 0, 0], // Black line
          lineWidth: 0.5,
        },
        headStyles: {
          fillColor: [200, 200, 200], // Gray background for headers
          textColor: [0, 0, 0], // Black text for headers
        },
        footStyles: {
          fillColor: [200, 200, 200], // Gray background for footers
          textColor: [0, 0, 0], // Black text for footers
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240], // Light gray background for alternate rows
        },
      };
      
    //   (doc as any).autoTable({ html: element, options })      
    // Use jspdf-autotable to parse and generate PDF table
     if (currentUrl.includes('spineatools'))
      {
        (doc as any).autoTable({ 
          html: element1, 
          startY: 150, 
          theme: 'grid',
          headerStyles:{fillColor: [226,0,26]}
      });
    }
    else
    {
      (doc as any).autoTable({ 
          html: element1, 
          startY: 150, 
          theme: 'grid',
          headerStyles:{fillColor: [0,0,0]}
      });
    }
    // Save the PDF
    doc.save('Spec_'+productCode+'.pdf');
  }
  
  generatePdfB(companyName: string, companyAddress: string, contactInfo:string, website:string, tableId: string, tableId2:string,tableId3:string,productCode:string,productName:string,userInputTable:string) {
    const doc = new jsPDF();
    // doc.setFont("bold");
    // doc.text(companyName, 20, 20);

    const url = this.router.url.toLocaleLowerCase();
    const currentUrl = window.location.href.toLowerCase();
    const logoImg = new Image();
     if (currentUrl.includes('spineatools'))
      {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_S.jpg';
        doc.addImage(logoImg, 'JPG', 10, 10, 80, 20);
    }
    else
    {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_PDF.png';
        doc.addImage(logoImg, 'PNG', 10, 10, 80, 15);
    }


    const d = new Date();
    doc.setFontSize(10);
    doc.text(d.toDateString(),15, 35);
    doc.setFont("bold");
    // doc.addFont('Roboto-Regular.ttf', 'Roboto', 'bold'); 
    doc.setFontSize(11);
    doc.text("Product Name - " + productName ,15, 40)
    doc.text("Product Code - " + productCode ,15, 45)
    // doc.setFont("bold");
    doc.setFontSize(11);
    doc.setFont('Times-Roman', 'bold'); 
      if (currentUrl.includes('spineatools'))
      {
        doc.text("SPINEA.",122, 15);
        doc.setFont('Times-Roman', 'normal');
        doc.text( "s.r.o., Ku Magašu 702/3, 080 01 Haniska,",122, 20);
        doc.text( "District of Prešov, Slovakia",122, 25);
        doc.text( "Tel: +421 51 77 00 155, Sales: +421 51 77 00 156",122, 30);
        doc.setFont('Times-Roman', 'bold');
        doc.text(website,122, 35);

      }
      else
      {
        doc.text(companyName,115, 15);
        doc.setFont('Times-Roman', 'normal');
        doc.text(companyAddress,115, 20);
        doc.text(contactInfo,115, 25);
        // doc.setFont("bold");
        doc.setFont('Times-Roman', 'bold');
        doc.text(website,115, 30);
      }

    
    // // Add company header
    // doc.setFontSize(18);
    // doc.text(companyName, 20, 20);
    // doc.setFontSize(12);
    // doc.text(companyAddress, 20, 30);

    // Get table data from HTML table
    const element = document.getElementById(tableId);
    // const options = { startY: 500 };
    const options = {
        startY: 20,
        theme: 'grid',
        styles: {
          lineColor: [0, 0, 0], // Black line
          lineWidth: 0.5,
        },
        headStyles: {
          fillColor: [200, 200, 200], // Gray background for headers
          textColor: [0, 0, 0], // Black text for headers
        },
        footStyles: {
          fillColor: [200, 200, 200], // Gray background for footers
          textColor: [0, 0, 0], // Black text for footers
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240], // Light gray background for alternate rows
        },
      };
      
    //   (doc as any).autoTable({ html: element, options });
      
if(currentUrl.includes('spineatools') ) {
    (doc as any).autoTable({ 
        html: element, 
        startY: 50, 
        theme: 'grid',
        headerStyles:{fillColor: [226, 0, 26]},
        columnStyles: {
          0: { cellWidth: 15 }, // First column width
          1: { cellWidth: 90 }, // Second column width
           // Third column width
          // You can add more columns if needed
      }
    });
  }
  else{
    (doc as any).autoTable({ 
        html: element, 
        startY: 50, 
        theme: 'grid',
        headerStyles:{fillColor: [0, 0, 0]},
        columnStyles: {
          0: { cellWidth: 15 }, // First column width
          1: { cellWidth: 90 }, // Second column width
           // Third column width
          // You can add more columns if needed
      }
    });
  }
	
	
	const userDataTable:any = document.getElementById(userInputTable);
  if(currentUrl.includes('spineatools') ) {
    (doc as any).autoTable({ 
      html: userDataTable, 
      startY: 50, 
      margin: { left: 125, top: 50 },
      theme: 'grid',
      headerStyles:{fillColor: [226, 0, 26]},
      columnStyles: {
        0: { cellWidth: 50 }, // First column width
        1: { cellWidth: 20 }, // Second column width
         // Third column width
        // You can add more columns if needed
    }
  });
}
else{
  (doc as any).autoTable({ 
      html: userDataTable, 
      startY: 50, 
      margin: { left: 125, top: 50 },
      theme: 'grid',
      headerStyles:{fillColor: [226, 0, 26]},
      columnStyles: {
        0: { cellWidth: 50 }, // First column width
        1: { cellWidth: 20 }, // Second column width
         // Third column width
        // You can add more columns if needed
    }
  });
}



    const element1 = document.getElementById(tableId2);
    // const options = { startY: 500 };
    const options1 = {
        startY: 40,
        theme: 'grid',
        styles: {
          lineColor: [0, 0, 0], // Black line
          lineWidth: 0.5,
        },
        headStyles: {
          fillColor: [200, 200, 200], // Gray background for headers
          textColor: [0, 0, 0], // Black text for headers
        },
        footStyles: {
          fillColor: [200, 200, 200], // Gray background for footers
          textColor: [0, 0, 0], // Black text for footers
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240], // Light gray background for alternate rows
        },
      };
      
    //   (doc as any).autoTable({ html: element, options });
      

    // Use jspdf-autotable to parse and generate PDF table
    if(currentUrl.includes('spineatools') ) {
    (doc as any).autoTable({ 
        html: element1, 
        startY: 155, 
        theme: 'grid',
        headerStyles:{fillColor: [226, 0, 26]}
    });
  }
  else{
    (doc as any).autoTable({
      html: element1, 
      startY: 155, 
      theme: 'grid',
      headerStyles:{fillColor: [0, 0, 0]}
    });
  }


    const element3 = document.getElementById(tableId3);
    if (currentUrl.includes('spineatools')) {
    (doc as any).autoTable({ 
      html: element3, 
      startY: 246, 
      theme: 'grid',
      headerStyles:{fillColor: [226, 0, 26]}
  });}
  else{
    (doc as any).autoTable({ 
      html: element3, 
      startY: 246, 
      theme: 'grid',
      headerStyles:{fillColor: [0, 0, 0]}
  });}
    // Save the PDF
    doc.save('Spec_'+productCode+'.pdf');
  }
  generatePdfF(companyName: string, companyAddress: string, contactInfo:string, website:string, tableId: string, tableId2:string,productCode:string,productName:string,userInputTable:string) {
    const doc = new jsPDF();
    // doc.setFont("bold");
    // doc.text(companyName, 20, 20);
    const url = this.router.url.toLocaleLowerCase();
    const currentUrl = window.location.href.toLowerCase();
    const logoImg = new Image();
    if (currentUrl.includes('spineatools'))
      {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_S.jpg';
        doc.addImage(logoImg, 'JPG', 10, 10, 80, 20);
    }
    else
    {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_PDF.png';
        doc.addImage(logoImg, 'PNG', 10, 10, 80, 15);
    }


    const d = new Date();
    doc.setFontSize(10);
    doc.text(d.toDateString(),15, 35);
    doc.setFont("bold");
    // doc.addFont('Roboto-Regular.ttf', 'Roboto', 'bold'); 
    doc.setFontSize(11);
    doc.text("Product Name - " + productName ,15, 40)
    doc.text("Product Code - " + productCode ,15, 45)
    // doc.setFont("bold");
    doc.setFontSize(11);
    doc.setFont('Times-Roman', 'bold'); 
    if (currentUrl.includes('spineatools'))
      {
        doc.text("SPINEA.",122, 15);
        doc.setFont('Times-Roman', 'normal');
        doc.text( "s.r.o., Ku Magašu 702/3, 080 01 Haniska,",122, 20);
        doc.text( "District of Prešov, Slovakia",122, 25);
        doc.text( "Tel: +421 51 77 00 155, Sales: +421 51 77 00 156",122, 30);
        doc.setFont('Times-Roman', 'bold');
        doc.text(website,122, 35);

      }
      else
      {
        doc.text(companyName,115, 15);
        doc.setFont('Times-Roman', 'normal');
        doc.text(companyAddress,115, 20);
        doc.text(contactInfo,115, 25);
        // doc.setFont("bold");
        doc.setFont('Times-Roman', 'bold');
        doc.text(website,115, 30);
      }

    
    // // Add company header
    // doc.setFontSize(18);
    // doc.text(companyName, 20, 20);
    // doc.setFontSize(12);
    // doc.text(companyAddress, 20, 30);

    // Get table data from HTML table
    const element = document.getElementById(tableId);
    // const options = { startY: 500 };
    const options = {
        startY: 20,
        theme: 'grid',
        styles: {
          lineColor: [0, 0, 0], // Black line
          lineWidth: 0.5,
        },
        headStyles: {
          fillColor: [200, 200, 200], // Gray background for headers
          textColor: [0, 0, 0], // Black text for headers
        },
        footStyles: {
          fillColor: [200, 200, 200], // Gray background for footers
          textColor: [0, 0, 0], // Black text for footers
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240], // Light gray background for alternate rows
        },
      };
      
    //   (doc as any).autoTable({ html: element, options });
      

    // Use jspdf-autotable to parse and generate PDF table
    if (currentUrl.includes('spineatools')){
    (doc as any).autoTable({ 
      html: element, 
      startY: 50, 
      theme: 'grid',
      headerStyles:{fillColor: [226,0,26]},
      columnStyles: {
        0: { cellWidth: 15 }, // First column width
        1: { cellWidth: 90 }, // Second column width
         // Third column width
        // You can add more columns if needed
    }
  });
}
else
  {
    (doc as any).autoTable({ 
      html: element, 
      startY: 50, 
      theme: 'grid',
      headerStyles:{fillColor: [0,0,0]},
      columnStyles: {
      0: { cellWidth: 15 }, // First column width
      1: { cellWidth: 90 }, // Second column width
       // Third column width
      // You can add more columns if needed
      }
    });
  }


const userDataTable:any = document.getElementById(userInputTable);
if (currentUrl.includes('spineatools'))
  {
        (doc as any).autoTable({ 
        html: userDataTable, 
        startY: 50, 
        margin: { left: 125, top: 50 },
        theme: 'grid',
        headerStyles:{fillColor: [226,0,26]},
        columnStyles: {
          0: { cellWidth: 50 }, // First column width
          1: { cellWidth: 20 }, // Second column width
          // Third column width
          // You can add more columns if needed
      }
    });
  }
  else
    {
        (doc as any).autoTable({ 
          html: userDataTable, 
          startY: 50, 
          margin: { left: 125, top: 50 },
          theme: 'grid',
          headerStyles:{fillColor: [0,0,0]},
          columnStyles: {
            0: { cellWidth: 50 }, // First column width
            1: { cellWidth: 20 }, // Second column width
            // Third column width
            // You can add more columns if needed
        }
      });
    }



    const element1 = document.getElementById(tableId2);
    // const options = { startY: 500 };
    const options1 = {
        startY: 40,
        theme: 'grid',
        styles: {
          lineColor: [0, 0, 0], // Black line
          lineWidth: 0.5,
        },
        headStyles: {
          fillColor: [200, 200, 200], // Gray background for headers
          textColor: [0, 0, 0], // Black text for headers
        },
        footStyles: {
          fillColor: [200, 200, 200], // Gray background for footers
          textColor: [0, 0, 0], // Black text for footers
        },
        alternateRowStyles: {
          fillColor: [240, 240, 240], // Light gray background for alternate rows
        },
      };
      
    //   (doc as any).autoTable({ html: element, options });
      

    // Use jspdf-autotable to parse and generate PDF table
    if (currentUrl.includes('spineatools'))
      {
        (doc as any).autoTable({ 
        html: element1, 
        startY: 144, 
        theme: 'grid',
        headerStyles:{fillColor: [226,0,26]}
        });
      } 
    else
    {   
          (doc as any).autoTable({ 
            html: element1, 
            startY: 144, 
            theme: 'grid',
            headerStyles:{fillColor: [0,0,0]}
        });
    }



    
    // Save the PDF
    doc.save('Spec_'+productCode+'.pdf');
  }

  generateDimensionalPDFRG(companyName: string, companyAddress: string, contactInfo:string, website:string, tableId: string, firstImg:string,secondImg:string,productCode:string,productName:string){
    const doc = new jsPDF('landscape', 'mm', 'a4');
    const url = this.router.url.toLocaleLowerCase();
    const currentUrl = window.location.href.toLowerCase();
    // const doc = new jsPDF('landscape', 'mm', 'a4');
    const logoImg = new Image();
    // const logoImg1 = new Image();
    // logoImg1.src = '../Powermate/assets/images/MainImages/'+firstImg;
    if (currentUrl.includes('spineatools'))
    {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_SP_small_New.png';
        
    }
    else
    {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_CD_small.png';
        
    }
    
    doc.addImage(logoImg, 'PNG', 10, 2,0,0);
    const d = new Date();
    doc.setFontSize(10);
    doc.text(d.toDateString(),255, 13.5);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.text("Product Name - " + productName ,15, 22)
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text("Product Code - " + productCode ,100, 16.5)
    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);
    if (currentUrl.includes('spineatools'))
    {
      doc.text("SPINEA.",25, 8);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");
      doc.text( "s.r.o., Ku Magašu 702/3, 080 01 Haniska, District of Prešov, Slovakia",27, 12);
      doc.text( "Tel: +421 51 77 00 155, Sales: +421 51 77 00 156",27, 16);
       if(firstImg)
        {
          doc.addImage(firstImg, 'PNG', 95, 19, 195, 130);
        }
    if(secondImg)
      {
        doc.addImage(secondImg, 'PNG', 95, 151, 195, 55);
      }
    }
    else
    {
      doc.text("Cone Drive Operations, Inc.",25, 8);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");
      doc.text( "240 E. 12th Street,Traverse City, Michigan USA 49684",27, 12);
      doc.text( "Tel: 231-946-8410, Sales: 888-994-2663",27, 16);
       if(firstImg){
      doc.addImage(firstImg, 'PNG', 95, 15, 195, 130);
    }
    if(secondImg){
      doc.addImage(secondImg, 'PNG', 95, 147, 195, 55);
    }
    }
    const element = document.getElementById(tableId);
    let headerFill: number[] = [0, 0, 0];
    if (currentUrl.includes('spineatools')) {
      headerFill = [226, 0, 26]; // Red color for SPINEA
    }
    (doc as any).autoTable({ 
        html: element, 
        startY: 25, 
        theme: 'grid',
        headStyles:{
          fillColor: headerFill,
          fontSize: 7,
          cellPadding: 1,
          halign: 'left',
          tableLineColor: 0,
          lineColor: 0,
          lineWidth: 0.01
        },styles: {
          overflow: 'linebreak',
          fontSize: 7, // Font size for body text
          cellPadding: 1, // Padding inside cells
          lineColor: [0, 0, 0], // Line color for body borders
          lineWidth: 0.01 // Line width for body borders
          
      },
        columnStyles: {
          0: { cellWidth: 10 },
          1: { cellWidth: 70 },
        },
        
        tableWidth: 'wrap',
    });

    // Save the PDF
    doc.save("Dim_" + productCode + ".pdf");
  }
  generateDimensionalPDF_F(companyName:string, companyAddress:string, contactInfo:string, website:string, tableId:string,productCode:string,productName:string,img_std_Dimensions:string,img_col10:string,img_col9_12:string,img_col11:string){
    const doc = new jsPDF('landscape', 'mm', 'a4');
    const url = this.router.url.toLocaleLowerCase();
    const currentUrl = window.location.href.toLowerCase();
    // const doc = new jsPDF('landscape', 'mm', 'a4');
    const logoImg = new Image();
    if (currentUrl.includes('spineatools'))
      {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_SP_small_New.png';
        
      }
    else
      {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_CD_small.png';
        
      }
    doc.addImage(logoImg, 'PNG', 10, 2,0,0);
    const d = new Date();
    doc.setFontSize(10);
    doc.text(d.toDateString(),255, 13.5);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.text("Product Name - " + productName ,15, 22)
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text("Product Code - " + productCode ,15, 28)
    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);
    if(currentUrl.includes('spineatools'))
      {
        doc.text("SPINEA.",25, 8);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.text( "s.r.o., Ku Magašu 702/3, 080 01 Haniska, District of Prešov, Slovakia",27, 12);
        doc.text( "Tel: +421 51 77 00 155, Sales: +421 51 77 00 156",27, 16);
      }
    else
      {
        doc.text("Cone Drive Operations, Inc.",25, 8);
        doc.setFont("helvetica", "normal");
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.text( "240 E. 12th Street,Traverse City, Michigan USA 49684",27, 12);
        doc.text( "Tel: 231-946-8410, Sales: 888-994-2663",27, 16);
      }



    if(img_std_Dimensions){
      doc.addImage(img_std_Dimensions, 'PNG', 100, 30, 125, 75);
    }
    if (productCode.substr(9, 1) != "W") {
      if (img_col10) {
          doc.addImage(img_col10, 'PNG', 230, 30, 55, 75);
      }
    }

    if (img_col9_12) {
      if (productCode.substr(8, 1) == "D") {
          doc.addImage(img_col9_12, 'PNG', 25, 120, 125, 80);
      }
      else {
          doc.addImage(img_col9_12, 'PNG', 25, 120, 125, 55);
      }
  
    }
    if (img_col11) {
      doc.addImage(img_col11, 'PNG', 160, 120, 125, 55);
    }


    const element = document.getElementById(tableId);
    let headerFill: number[] = [0, 0, 0];
    if(currentUrl.includes('spineatools')) {
      headerFill = [226, 0, 26]; // Red color for SPINEA
    }
    (doc as any).autoTable({ 
        html: element, 
        startY: 30, 
        theme: 'grid',
        headStyles:{
          fillColor: headerFill,
          fontSize: 7,
          cellPadding: 1,
          halign: 'left',
          tableLineColor: 0,
          lineColor: 0,
          lineWidth: 0.01
        },styles: {
          overflow: 'linebreak',
          fontSize: 7, // Font size for body text
          cellPadding: 1, // Padding inside cells
          lineColor: [0, 0, 0], // Line color for body borders
          lineWidth: 0.01 // Line width for body borders
          
      },
        columnStyles: {
          0: { cellWidth: 10 },
          1: { cellWidth: 70 },
        },
        
        tableWidth: 'wrap',
    });

    doc.save("Dim_" + productCode + ".pdf");
  }
  


  generateDimensionalPDF_B(companyName:string, companyAddress:string, contactInfo:string, website:string, tableId:string,productCode:string,productName:string,img_std_Dimensions:string,img_col9:string,img_col10_12:string,img_col11:string){
     // const doc = new jsPDF('landscape', 'mm', 'a4');
    const doc = new jsPDF('landscape', 'mm', 'a4');
    const url = this.router.url.toLocaleLowerCase();
    const currentUrl = window.location.href.toLowerCase();
    // const doc = new jsPDF('landscape', 'mm', 'a4');
    const logoImg = new Image();
    // const logoImg1 = new Image();
    // logoImg1.src = '../Powermate/assets/images/MainImages/'+firstImg;
     if (currentUrl.includes('spineatools'))
    {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_SP_small_New.png';
        
    }
    else
    {
        logoImg.src = this.AssetbasePath+'/images/MainImages/Logo_CD_small.png';
        
    }
    doc.addImage(logoImg, 'PNG', 10, 2,0,0);
    const d = new Date();
    doc.setFontSize(10);
    doc.text(d.toDateString(),255, 13.5);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(11);
    doc.text("Product Name - " + productName ,15, 22)
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text("Product Code - " + productCode ,15, 28)
    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);
    if(currentUrl.includes('spineatools'))
    {
      doc.text("SPINEA.",25, 8);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");
      doc.text( "s.r.o., Ku Magašu 702/3, 080 01 Haniska, District of Prešov, Slovakia",27, 12);
      doc.text( "Tel: +421 51 77 00 155, Sales: +421 51 77 00 156",27, 16);
    }
    else
    {
      doc.text("Cone Drive Operations, Inc.",25, 8);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8);
      doc.setFont("helvetica", "normal");
      doc.text( "240 E. 12th Street,Traverse City, Michigan USA 49684",27, 12);
      doc.text( "Tel: 231-946-8410, Sales: 888-994-2663",27, 16);
    }



    if(img_std_Dimensions){
      doc.addImage(img_std_Dimensions, 'PNG', 100, 30, 125, 75);
    }
    if (productCode.substr(8, 1) != "W") {
      if (img_col9) {
          doc.addImage(img_col9, 'PNG', 230, 30, 50, 75);
      }
    }


    if (img_col10_12) {
      if ((productCode.substr(14, 1) == "G") || (productCode.substr(14, 1) == "H")) {
          if (productCode.substr(1, 2) == "02") {
              doc.addImage(img_col10_12, 'PNG', 8, 120, 160, 70);
          } else if (productCode.substr(1, 2) == "03") {
              doc.addImage(img_col10_12, 'PNG', 8, 120, 160, 52);
          } else if (productCode.substr(1, 2) == "04") {
              doc.addImage(img_col10_12, 'PNG', 8, 120, 160, 52);
          } else if (productCode.substr(1, 2) == "05") {
              doc.addImage(img_col10_12, 'PNG', 8, 120, 160, 52);
          } else if (productCode.substr(1, 2) == "06") {
              doc.addImage(img_col10_12, 'PNG', 8, 120, 160, 52);
          } else if (productCode.substr(1, 2) == "08") {
              doc.addImage(img_col10_12, 'PNG', 8, 120, 160, 52);
          } else if (productCode.substr(1, 2) == "09") {
              doc.addImage(img_col10_12, 'PNG', 8, 120, 160, 52);
          } else if (productCode.substr(1, 2) == "10") {
              doc.addImage(img_col10_12, 'PNG', 8, 120, 160, 52);
          } else if (productCode.substr(1, 2) == "11") {
              doc.addImage(img_col10_12, 'PNG', 8, 120, 160, 52);
          }
      }
      else
      {
          if (productCode.substr(1, 2) == "11") {
              if ((productCode.substr(9, 1) == "R") && (productCode.substr(11, 1) == "-") || (productCode.substr(9, 1) == "A") && (productCode.substr(11, 1) == "Q") || (productCode.substr(9, 1) == "A") && (productCode.substr(11, 1) == "R") || (productCode.substr(9, 1) == "A") && (productCode.substr(11, 1) == "T") || (productCode.substr(9, 1) == "A") && (productCode.substr(11, 1) == "V")) {
                  doc.addImage(img_col10_12, 'PNG', 8, 120, 160, 52);
              } else {
                  doc.addImage(img_col10_12, 'PNG', 8, 120, 160, 52);
              }
  
          } else if (productCode.substr(1, 2) == "04") {
              if ((productCode.substr(9, 1) == "R") && (productCode.substr(11, 1) == "-") || (productCode.substr(9, 1) == "A") && (productCode.substr(11, 1) == "T") || (productCode.substr(9, 1) == "A") && (productCode.substr(11, 1) == "V") || (productCode.substr(9, 1) == "A") && (productCode.substr(11, 1) == "X")) {
                  doc.addImage(img_col10_12, 'PNG', 8, 120, 160, 52);
              } else {
                  doc.addImage(img_col10_12, 'PNG', 8, 120, 160, 52);
              }
          }
          else {
              doc.addImage(img_col10_12, 'PNG', 15, 120, 125, 55);
          }
          
      }
  }
      
  if (img_col11) {
    if ((productCode.substr(14, 1) == "G") || (productCode.substr(14, 1) == "H")) {

        if (productCode.substr(1, 2) == "02") {
            doc.addImage(img_col11, 'PNG', 170, 120, 125, 60);
        } else if (productCode.substr(1, 2) == "03") {
            doc.addImage(img_col11, 'PNG', 170, 120, 125, 52);
        } else if (productCode.substr(1, 2) == "04") {
            doc.addImage(img_col11, 'PNG', 170, 120, 125, 52);
        } else if (productCode.substr(1, 2) == "05") {
            doc.addImage(img_col11, 'PNG', 170, 120, 125, 52);
        } else if (productCode.substr(1, 2) == "06") {
            doc.addImage(img_col11, 'PNG', 170, 120, 125, 52);
        } else if (productCode.substr(1, 2) == "08") {
            doc.addImage(img_col11, 'PNG', 170, 120, 125, 52);
        } else if (productCode.substr(1, 2) == "09") {
            doc.addImage(img_col11, 'PNG', 170, 120, 125, 52);
        } else if (productCode.substr(1, 2) == "10") {
            doc.addImage(img_col11, 'PNG', 170, 120, 125, 52);
        } else if (productCode.substr(1, 2) == "11") {
            doc.addImage(img_col11, 'PNG', 170, 120, 125, 52);
        }
    }
    else {

        if (productCode.substr(1, 2) == "11") {
            if ((productCode.substr(9, 1) == "R") && (productCode.substr(11, 1) == "-") || (productCode.substr(9, 1) == "A") && (productCode.substr(11, 1) == "Q") || (productCode.substr(9, 1) == "A") && (productCode.substr(11, 1) == "R") || (productCode.substr(9, 1) == "A") && (productCode.substr(11, 1) == "T") || (productCode.substr(9, 1) == "A") && (productCode.substr(11, 1) == "V")) {
                doc.addImage(img_col11, 'PNG', 170, 120, 125, 52);
            } else {
                doc.addImage(img_col11, 'PNG', 170, 120, 125, 52);
            }

        } else if (productCode.substr(1, 2) == "04") {
            if ((productCode.substr(9, 1) == "R") && (productCode.substr(11, 1) == "-") || (productCode.substr(9, 1) == "A") && (productCode.substr(11, 1) == "T") || (productCode.substr(9, 1) == "A") && (productCode.substr(11, 1) == "V") || (productCode.substr(9, 1) == "A") && (productCode.substr(11, 1) == "X")) {
                doc.addImage(img_col11, 'PNG', 170, 120, 125, 52);
            } else {
                doc.addImage(img_col11, 'PNG', 170, 120, 125, 52);
            }
        }else {
            doc.addImage(img_col11, 'PNG', 145, 120, 125, 55);
        }
        
    }
}

    // if(img_col10){
    //   doc.addImage(img_col10, 'PNG', 95, 15, 195, 130);
    // }
    // if(img_col9_12){
    //   doc.addImage(img_col9_12, 'PNG', 95, 147, 195, 55);
    // }
    // if(img_col11){
    //   doc.addImage(img_col11, 'PNG', 95, 200, 195, 55);
    // }
    

    const element = document.getElementById(tableId);
    let headerFill: number[] = [0, 0, 0];
    if (currentUrl.includes('spineatools')) {
      headerFill = [226, 0, 26]; // Red color for SPINEA
    }
    (doc as any).autoTable({ 
        html: element, 
        startY: 30, 
        theme: 'grid',
        headStyles:{
          fillColor: headerFill,
          fontSize: 7,
          cellPadding: 1,
          halign: 'left',
          tableLineColor: 0,
          lineColor: 0,
          lineWidth: 0.01
        },styles: {
          overflow: 'linebreak',
          fontSize: 7, // Font size for body text
          cellPadding: 1, // Padding inside cells
          lineColor: [0, 0, 0], // Line color for body borders
          lineWidth: 0.01 // Line width for body borders
          
      },
        columnStyles: {
          0: { cellWidth: 10 },
          1: { cellWidth: 70 },
        },
        
        tableWidth: 'wrap',
    });

    doc.save("Dim_" + productCode + ".pdf");
  }
}
